export default "__VITE_ASSET__77e89c04__"